import { render, staticRenderFns } from "./ShipDeliveryHistoryTable.vue?vue&type=template&id=3b433b0c&scoped=true&"
import script from "./ShipDeliveryHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ShipDeliveryHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipDeliveryHistoryTable.vue?vue&type=style&index=0&id=3b433b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b433b0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VCheckbox,VDataTable,VExpansionPanel,VExpansionPanelContent,VExpansionPanels})
